import styled from 'styled-components';

export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  padding: 0;
  margin: 0;
`;

export const TermsText = styled.div`
  margin: 20px auto 20px auto;
  font-size: 1em;
  padding: 0 2rem 1rem 2rem;
  max-width: 1200px;
  
`;

export const ButtonWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 1rem 0;
`;

export const ButtonContainer = styled.div`
  width: 50%;
`;

export const LogoWrapper = styled.img`
    margin-bottom: 30px;
    display: block;
    margin-left: auto;
    margin-right: auto;
`;